"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nextFrame = function (fn) {
    var raf = window.requestAnimationFrame;
    raf(function () { return raf(fn); });
};
exports.default = nextFrame;
